import * as React from "react";
import { GameContext } from "./game.context";

export function useGameContext() {
  const [gameState, actionHandlers] = React.useContext(GameContext);

  return { gameState, actionHandlers };
}
